import React from 'react';
import Group from 'containers/Group';
import renderFields from 'utils/renderFields';

const isNotExcluded = (groupName) => {
  const excludedGroups = ['PRIMARY_MOBILE_VERIFICATION'];

  return excludedGroups.indexOf(groupName) === -1;
};

const renderGroups = (groups) => (
  <form noValidate onSubmit={(e) => e.preventDefault()}>
    {Object.keys(groups).map(
      (groupName) =>
        isNotExcluded(groupName) && (
          <Group key={groupName} name={groupName}>
            <div className="fields-view">{renderFields(groups[groupName])}</div>
          </Group>
        ),
    )}
  </form>
);

export default renderGroups;
